import { useEffect, useState } from 'react'
import { get } from '@sales-center/common'
import { EntityLocations, ENTITY_TYPES } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { useSelector } from 'react-redux'
import {
  selectAddOpportunitySlice,
  setAddOppBillTo,
  setAddOppLocations,
} from '@user/store/opportunity/addOpportunity/addOpportunitySlice'
import { useAppDispatch } from '@user/store/hooks'

type State = {
  loading: boolean
}

const initialState: State = {
  loading: false,
}

export function useGetEntityLocations(
  entityType: ENTITY_TYPES,
  entityId: number | undefined,
) {
  const [state, setState] = useState(initialState)
  const { loading } = state
  const dispatch = useAppDispatch()
  const { billTo, serviceLocations } = useSelector(selectAddOpportunitySlice)

  useEffect(() => {
    async function fetchFromApi() {
      const path =
        entityType === ENTITY_TYPES.Lead
          ? `${ServiceConfig.location.lead}/Lead`
          : `${ServiceConfig.location.opp}/Opportunity`

      setState((state) => ({ ...state, loading: true }))

      const response = await get(
        `${ServiceConfig.baseAPIUrl}/${path}/${entityId}`,
      )
      if (response.ok) {
        const locations: EntityLocations = await response.json()
        setState(() => ({
          loading: false,
        }))
        dispatch(setAddOppBillTo(locations.billToLocations[0]))
        dispatch(setAddOppLocations(locations.serviceLocations))
      } else {
        setState(() => ({ loading: false }))
      }
    }

    if (entityId) {
      fetchFromApi()
    } else {
      setState(() => ({ loading: false }))
    }
  }, [dispatch, entityId, entityType])

  return { billTo, serviceLocations, loading }
}
